import { type AxiosPromise } from 'axios';
import { httpWithAuth } from '~/clients';
import { ADD_FAVORITES } from '~/constants/endpoints';
import type { FavoriteVehicle } from '~/contracts/common';

export default function addFavorite({
  subscribeToNotifications,
  vehicleId
}: {
  subscribeToNotifications: boolean;
  vehicleId: number;
}): AxiosPromise<FavoriteVehicle | null> {
  return httpWithAuth.post(ADD_FAVORITES, {
    subscribeToWIPNotifications: subscribeToNotifications,
    vehicleId
  });
}
